import { Loading } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { useFetchCurrentBloomMenu } from '@jane/business-admin/data-access';

export const RequirePremiumAccess = ({ children }: PropsWithChildren) => {
  const { data, isLoading, isFetched } = useFetchCurrentBloomMenu();

  if (isLoading || !isFetched) {
    return <Loading />;
  }

  if (!data?.menu_url) {
    return <Navigate to="/" />;
  }
  return <>{children}</>;
};
